<template>
    <div class="partner">
        <div class="header_btn">
            <div>
                <el-input v-model="supplierName" style="width: 240px;" placeholder="供应商名称" clearable />
                <el-select class="force-style-input" v-model="partnerCode" placeholder="所属合作方" size="large" clearable
                    style="width: 240px;margin-left: 10px;">
                    <el-option v-for="item in options" :key="item.partnerCode" :label="item.abbreviation"
                        :value="item.partnerCode" />
                </el-select>
                 <el-button  size="large" style="margin-left: 10px;" 
                    @click="resetBtn">重置</el-button>
                <el-button type="primary" size="large" style="margin-left: 10px;" :loading="searchState"
                    @click="searchBtn"><el-icon class="cancelgu">
                        <Search />
                    </el-icon>搜索</el-button>
            </div>
            <el-button type="primary" :icon="Plus" @click="addSupplier" class="common_btn">添加</el-button>
        </div>
        <div class="count">统计：{{ count }}条</div>

        <el-table :data="filterTableData" style="width: 100%;margin-bottom: 15px;" row-key="unionId" border
            :header-cell-style="{ background: '#F5F7FA' }" :empty-text="texts" v-loading="showLoading">
            <!-- 供应商名称   -->
            <el-table-column fixed label="供应商名称" prop="supplierName" align="center" :show-overflow-tooltip='true'
                width="150">
            </el-table-column>
            <!-- 所属合作方  -->
            <el-table-column label="所属合作方 " prop="partnerName" align="center" :show-overflow-tooltip='true' width="160">
            </el-table-column>
            <!-- 联系人姓名  -->
            <el-table-column label="联系人姓名 " prop="contacts" align="center" :show-overflow-tooltip='true' width="160">
            </el-table-column>
            <!-- 联系方式  -->
            <el-table-column label="联系方式 " prop="mobile" align="center" :show-overflow-tooltip='true' width="160">
            </el-table-column>
            <!-- 邮箱  -->
            <el-table-column label="邮箱 " prop="email" align="center" :show-overflow-tooltip='true' width="200">
            </el-table-column>
            <!-- 地址  -->
            <el-table-column label="地址 " prop="address" align="center" :show-overflow-tooltip='true'>
            </el-table-column>
            <!-- 创建时间  -->
            <el-table-column label="创建时间 " prop="createTime" align="center" :show-overflow-tooltip='true' width="160"
                :formatter="reach">
            </el-table-column>
            <!-- 备注  -->
            <el-table-column label="备注 " prop="remarks" align="center" :show-overflow-tooltip='true' width="160">
            </el-table-column>
            <!-- 操作 -->
            <el-table-column label="操作" align="center" width="150" :show-overflow-tooltip='true'>
                <template #default="scope">
                    <el-button size="default" class="bulur" @click="editPartner(scope.row.id)"><el-icon>
                            <EditPen />
                        </el-icon>编辑</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 表格分页 -->
        <el-pagination hide-on-single-page="true" layout="prev, pager, next,sizes" :page-sizes="[6, 12, 18, 24]"
            :current-page="currentPage" :page-size="pagesize" :total="count" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
    </div>
</template>
<script setup>
import { Plus, EditPen, Search } from '@element-plus/icons-vue'
import { ref, onMounted } from 'vue';
import moments from 'moment'
import {
    supplierTableData, getpartnerData
} from "../../../request/api";
import {
    useRouter,
} from "vue-router";
import qs from 'qs';
const showLoading = ref(true); //加载loading

const router = useRouter()
// 表格数据
const filterTableData = ref([]);
//合作方列表
const options = ref([]);
// 总计条数
const count = ref(0);
// 供应商名称
const supplierName = ref('');
// 所属合作方
const partnerCode = ref('');
// 搜索状态
const searchState = ref(false);
// 分页
const currentPage = ref(1); // 当前页码
const pagesize = ref(6); // 每页显示条数
// 表格数据方法
const dataInfo = () => {
    let params = {
        supplierName: supplierName.value,
        partnerCode: partnerCode.value,
        page: String(currentPage.value),
        limit: String(pagesize.value),
    }
    supplierTableData(qs.stringify(params)).then((res) => {
        if (res.data.code == 0) {
            filterTableData.value = res.data.data.supplierPage.list;
            count.value = res.data.data.supplierPage.totalCount;
            showLoading.value = false;
        }
    })
}
const partnerList = () => {
    getpartnerData().then((res) => {
        if (res.data.code == 0) {
            options.value = res.data.data.partnerCodeList;
        }
    })
}
// 定义 reach 方法
const reach = (row, column, cellValue) => {
    // 这里可以添加格式化时间的逻辑
    if (cellValue) {
        return moments(cellValue * 1000).format("YYYY-MM-DD HH:mm")
    }
    return '';
};
// 搜索
const searchBtn = () => {
    showLoading.value = true;
    currentPage.value = 1;
    dataInfo();
}
// 重置
const resetBtn = () => {
    supplierName.value = '';
    partnerCode.value = '';
    currentPage.value = 1;
    pagesize.value = 6;
    showLoading.value = true;  
    dataInfo();
}
const handleSizeChange = (val) => {
    showLoading.value = true;
    pagesize.value = val;
    dataInfo();
}
const handleCurrentChange = (val) => {
    currentPage.value = val;
    showLoading.value = true;
    dataInfo();
}
// 跳转添加
const addSupplier = () => {
    router.push({ path: '/supplierManagement/add' })
}
// 跳转编辑
const editPartner = (id) => {
    router.push({ path: '/supplierManagement/edit' })
    sessionStorage.setItem('supplierId', id);
}
onMounted(() => {
    partnerList(); //合作方数据
    dataInfo(); // 列表数据
})
</script>
<style lang="scss" scoped>
.bulur {
    color: #409eff;
    border: none;
    --el-button-bg-color: none;
    --el-button-hover-bg-color: none;
    --el-button-hover-text-color: none;
}

.bulur:hover {
    color: #a0cfff;
}

.partner {
    height: calc(100vh - 170px);
    background-color: #FFFFFF;
    width: 95%;
    padding: 20px;
    overflow: auto;
    box-shadow: var(--el-box-shadow-light);
    border-radius: 5px;
    margin: 15px auto;
}

.header_btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.count {
    font-size: 14px;
    color: #909399;
    margin-bottom: 15px;
}



.force-style-input {
    height: 40px;
    line-height: 40px;
}

.common_btn {
    height: 39px;
    line-height: 39px;
    margin-left: 10px;
}

::v-deep .el-input__inner {
    height: 40px;
    line-height: 40px;
}

.cancelgu {
    margin-right: 6px;
    font-weight: bold;
}
</style>
